import { useState } from "react"
import { PageHeader } from "../../common/ui"
import { RequireRole } from "../../common/validation"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants/navbar"
import NewCustomerForm from "./components/new-customer-form"
import SuccessMessage from "./components/success-message"

interface CreatedOrg {
  id: string
  name: string
}

const NewCustomer = () => {
  const [createdOrg, setCreatedOrg] = useState<CreatedOrg | null>(null)

  const handleSuccess = (orgId: string, orgName: string) => {
    setCreatedOrg({ id: orgId, name: orgName })
  }

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE["new-customer"]}>
      <div className="p-6 max-w-3xl mx-auto">
        <PageHeader title="New Customer" className="mb-6" />
        {createdOrg ? (
          <SuccessMessage orgId={createdOrg.id} orgName={createdOrg.name} />
        ) : (
          <NewCustomerForm onSuccess={handleSuccess} />
        )}
      </div>
    </RequireRole>
  )
}

export default NewCustomer
